import { Check } from "lucide-react";
const features = [{
  title: "Discovery & Analysis",
  description: "We begin with a deep dive into your market architecture. Our team identifies structural opportunities and data-driven insights to establish a baseline for your brand's competitive evolution."
}, {
  title: "Strategic Blueprinting",
  description: "Crafting high-precision roadmaps that align creative execution with business objectives. We build the framework for sustainable growth using elite-level media planning and positioning."
}, {
  title: "Execution & Optimization",
  description: "Deploying multi-variate campaigns with surgical precision. We continuously refine performance metrics to ensure your brand maintains its architectural edge in dynamic global markets."
}];
export default function HowItWorks() {
  return <section data-section-id="241083" id="comprehensive-marketing-solutions" className="relative bg-background text-foreground py-24 lg:py-32 bg-fixed bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/architectural_obsidian_structure.png)]">
      {}
      <div className="absolute inset-0 bg-background/90 backdrop-blur-sm"></div>

      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl">
        <h2 className="text-4xl md:text-5xl font-default font-bold text-center mb-16 text-white tracking-tighter">
          Our Strategic Methodology
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-start group">
              <Check className="w-8 h-8 text-primary mb-6 shrink-0 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="text-2xl font-default font-bold text-white mb-4 tracking-tight">
                {feature.title}
              </h3>
              <p className="text-muted-foreground font-sans leading-relaxed text-base">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}